import React from 'react';

interface MessageProps {
  role: string;
  date: string;
  content: string;
  currentLang: 'es' | 'en';
  onFold?: () => void;
  assistantId: string;
}

const Message: React.FC<MessageProps> = ({ role, date, content, currentLang, onFold, assistantId }) => {
  // Si el role coincide con el asistente, mostrar 'AVA'
  const displayRole = role === assistantId ? 'AVA' : role;
  return (
    <div className="mensaje">
      <div className="meta">
        <strong>{displayRole}</strong> —{' '}
        {new Date(date).toLocaleTimeString(
          currentLang === 'es' ? 'es-ES' : 'en-US',
          { hour: '2-digit', minute: '2-digit' }
        )}
      </div>
      <div className="content">{content}</div>
      {onFold && (
        <button className="fold-btn" onClick={onFold}>
          <svg viewBox="0 0 24 12" width="24" height="12">
            <path d="M3 9l9-7 9 7" fill="none" stroke="currentColor" strokeWidth="3" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Message; 